class DateFormatter {
	static formatDate(dateStr) {
		const date = new Date(dateStr);
		return date.toLocaleString("en-US", {
			year: "numeric",
			month: "long",
			day: "numeric",
			// timeZoneName: 'short',
		});
	}
}

export default DateFormatter;
